import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { zones } from '@/mocks/zones';

export default function ZonesSection() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <SectionHeading
        eyebrow="Hot Zones"
        title="热门讨论区推荐"
        tone="light"
        desc="按互动速度与跟帖深度综合排序，下面这些讨论区正在持续发酵。热度每小时刷新一次。"
      />

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {zones.map((zone, index) => (
          <Reveal key={zone.id} delay={index * 60}>
            <article className="h-full bg-background-50 border border-background-200 rounded-lg overflow-hidden group">
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={zone.image}
                  alt={`${zone.name}讨论区封面`}
                  title={`${zone.name} · 爆料专区讨论区`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs whitespace-nowrap">
                  {zone.tag}
                </span>
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-start justify-between gap-3">
                  <h3 className="font-heading text-lg font-semibold text-foreground-950">{zone.name}</h3>
                  <span className="inline-flex items-center gap-1 text-xs text-primary-600 whitespace-nowrap shrink-0">
                    <i className="ri-fire-line" />
                    {zone.hot.toLocaleString()}
                  </span>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{zone.summary}</p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-3">
                  <span className="text-xs text-foreground-400">{zone.meta}</span>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    进入讨论区
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}